import { ErrorBanner, NeutralBanner, WarningBanner } from 'ui/banner';

export const HelperBanner = ({ bannerMsg }: { bannerMsg: string }) => {
  if (bannerMsg.includes('Whoops')) {
    return <NeutralBanner>{bannerMsg}</NeutralBanner>;
  }
  if (bannerMsg.includes('This is taking longer')) {
    return <WarningBanner>{bannerMsg}</WarningBanner>;
  }
  return <ErrorBanner>{bannerMsg}</ErrorBanner>;
};
